// extracted by mini-css-extract-plugin
export var copyable = "_m-1";
export var explainable = "_m-0";
export var negative = "_m-2";
export var positive = "_m-3";